import { useQuery } from "@tanstack/react-query";
import { Control, FieldError, FieldValues } from "react-hook-form";

import { Label, Larger } from "@/components/Forms";
import { NewDropdown } from "@/components/Forms/Dropdown";
import ValidationMessage from "@/components/Forms/ValidationMessage";
import { TestingAudienceResource } from "@/types/resources";
import { api } from "@/utils/api";

interface Props<T extends FieldValues> {
  control: Control<T>;
  error?: FieldError;
}

const TestingAudienceField = <T extends FieldValues>({
  error,
  control,
}: Props<T>) => {
  const { data } = useQuery(
    ["testing_audiences"],
    () => api.get<never, TestingAudienceResource[]>("/v1/testing-audiences"),
    {
      staleTime: 120 * 1000,
      select: (data) => [
        { label: "No Testing Audience", value: 0 },
        ...data.map((c) => ({ label: c.name, value: c.id })),
      ],
    }
  );
  return (
    <Larger>
      <Label htmlFor="testingAudienceInput">Testing Audience</Label>
      <NewDropdown<number>
        control={control}
        name="testing_audience_id"
        id="testingAudienceInput"
        options={data ?? []}
      />
      {!!error && <ValidationMessage>{error.message}</ValidationMessage>}
    </Larger>
  );
};

export default TestingAudienceField;
